import { connect } from 'react-redux';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { callFlowsActions } from '../../../../powerCallFlow/actions/callFlowsActions';
import * as telephonyActions from '../../../actions/telephony';
import EditNumberModal from '../../../components/sections/telephony/modals/editNumberModal';
export const { telephonyShowEditNumberModal, telephonyHideEditNumberModal, telephonyUpdateNumber, updateNumber, setLabel, getAllNumbers, } = telephonyActions.actions;
const { telephonyGetQueryNumbersPage, callFlowsFetchAll } = callFlowsActions;
const getInitialValues = (selectedNumber) => {
    const { name, record_outbound_calls } = selectedNumber || {};
    return {
        name: name !== null && name !== void 0 ? name : '',
        record_outbound_calls: record_outbound_calls !== null && record_outbound_calls !== void 0 ? record_outbound_calls : false,
    };
};
const mapStateToProps = (state, ownProps) => {
    const { selectedNumber } = state.settings.telephony;
    const initialValues = getInitialValues(selectedNumber !== null && selectedNumber !== void 0 ? selectedNumber : ownProps.selectedNumber);
    return {
        meta: state.settings.telephony.meta,
        numbers: state.settings.telephony.numbers,
        organizationId: state.settings.organization.organization.id,
        selectedNumber: state.settings.telephony.selectedNumber,
        newNumberLabel: state.settings.telephony.newNumberLabel,
        featureflags: state.settings.organization.featureflags,
        initialValues,
    };
};
const mapDispatchToProps = (dispatch) => ({
    showEditNumberModal: (number) => dispatch(telephonyShowEditNumberModal(number)),
    hideEditNumberModal: bindActionToPromise(dispatch, telephonyHideEditNumberModal),
    updateNumber: bindActionToPromise(dispatch, telephonyUpdateNumber),
    onChangePhoneLabel: bindActionToPromise(dispatch, setLabel),
    // @TODO: clean this up when merging CallflowsList
    callFlowsFetchAll: bindActionToPromise(dispatch, callFlowsFetchAll),
    telephonyGetQueryNumbersPage: bindActionToPromise(dispatch, telephonyGetQueryNumbersPage),
});
const mapOwnProps = (state, dispatch, own) => (Object.assign(Object.assign(Object.assign({}, state), dispatch), own));
export default connect(mapStateToProps, mapDispatchToProps, mapOwnProps)(EditNumberModal);
